import { useState, useEffect, useCallback } from "react";
import { supabase } from "../lib/supabaseClient";

export function useCreditBalance(): { balance: number | null; reload: () => void } {
  const [balance, setBalance] = useState<number | null>(null);

  const load = useCallback(async () => {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) {
      setBalance(null);
      return;
    }
    const { data } = await (supabase as any)
      .from("user_credits")
      .select("balance")
      .eq("user_id", user.id)
      .maybeSingle();
    setBalance((data as any)?.balance ?? 0);
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event) => {
      if (event === "SIGNED_IN" || event === "TOKEN_REFRESHED") {
        load();
      }
      if (event === "SIGNED_OUT") {
        setBalance(null);
      }
    });
    return () => subscription.unsubscribe();
  }, [load]);

  return { balance, reload: load };
}
